import { type BigIntish, MathLib } from '@morpho-org/blue-sdk'
import { toBigInt } from '@morpho-org/dapp-core'

interface AdjustedFallbackHealthMetricsParams {
  lltv: BigIntish | null | undefined
  protectedLltv: BigIntish | null | undefined
  liquidationPrice: bigint | null | undefined
}

export const getAdjustedFallbackHealthMetrics = ({
  lltv,
  protectedLltv,
  liquidationPrice
}: AdjustedFallbackHealthMetricsParams) => {
  const baseLltv = toBigInt(lltv)
  const adjustedLltv = toBigInt(protectedLltv)

  const fallbackMetrics = {
    liquidationPrice: liquidationPrice ?? null
  }

  if (
    baseLltv == null ||
    adjustedLltv == null ||
    baseLltv === adjustedLltv ||
    baseLltv === 0n ||
    adjustedLltv === 0n
  ) {
    return fallbackMetrics
  }

  const adjustedLiquidationPrice =
    fallbackMetrics.liquidationPrice == null
      ? null
      : MathLib.mulDivUp(fallbackMetrics.liquidationPrice, baseLltv, adjustedLltv)

  return {
    liquidationPrice: adjustedLiquidationPrice
  }
}
